import { NSFunctions } from './utils/functions';
import { Map as Module_Map } from './map';
import { NSCRS } from './utils/crs';

import { xCore, xCoreHelper } from './core';
 

export let NSMapInterface = {};

NSMapInterface.init = function()
{
    NSMapInterfacePrivate.init();
	
    this.f_set_default_layer =                              function () { return NSMapInterfacePrivate.f_set_default_layer.apply( NSMapInterfacePrivate, arguments ); };
	this.f_if_iframe_is_visible_activate_default_map = 	    function () { return NSMapInterfacePrivate.f_if_iframe_is_visible_activate_default_map.apply( NSMapInterfacePrivate, arguments ); };
	this.f_open_vistas_sv_mode =    	                    function () { return NSMapInterfacePrivate.f_open_vistas_sv_mode.apply( NSMapInterfacePrivate, arguments ); };
	
	//window.NSMapInterface = NSMapInterface;
	window.NSMapInterface_ = NSMapInterface;
	window.NSMapInterfacePrivate_ = NSMapInterfacePrivate;
	
}


let NSMapInterfacePrivate =
{
    private_objs: {
        a_layers: [{ internal_name: "carto_main_basemap", external_name: "Carto" }],
        a_layers_ortos: [],
        a_layers_vista_3d: [],
        a_layers_atlas: [],

        e_div_map_base_layer_select: null,
        e_div_ortos_layer_select: null,
        e_div_vistas_mode_button: null,
        e_div_vista3d_layer_select: null,
        e_div_atlas_layer_select: null,

        o_dd_carto: null,    // {objs.DropDownMapBaseLayer}
        o_dd_ortos: null,    // {objs.DropDownMapBaseLayer}
        o_dd_vista3d: null,    // {objs.DropDownMapBaseLayer}
        o_dd_atlas: null,    // {objs.DropDownMapBaseLayer}

        b_atlas_menu_is_available: null,    // indicates whether atlas menus is available in the page (in the internet should not be)

        o_mini_client: {
            e_button_map_base_layer_carto: null,
            e_button_map_base_layer_orto: null
        },

        ENUM_MAP_VIEWPORT_MODE: Object.freeze({ 
            CARTO: 'CARTO', 
            ORTOS: 'ORTOS', 
            VISTAS: 'VISTAS', 
            VISTA3D_MENU: 'VISTA3D_MENU', 
            ATLAS: 'ATLAS'
        })

    },

    init: function()
    {
        this.objs.init();
        this.f_load_ortos_info();
        this.f_load_vista3d_info();
        this.f_load_atlas_info();
        this.f_create_page_html();
        this.f_set_default_layer();

    },

    f_set_default_layer: function()
    {
        this.f_unset_iframe();  // unset vistas and vista_3d iframe

        //this.private_objs.a_e_div_option[0].onclick();
        if( !xCoreHelper.f_page_is_in_mini_client_mode() )
        {
            this.private_objs.o_dd_carto.f_trigger_default_layer();
        }
        else
        {
            this.f_carto_option_click_for_mini_client_version();
        }
    },

    f_load_ortos_info: function() {

        let a_layers_ortos = Module_Map.f_get_ortos_info();

        this.private_objs.a_layers_ortos = a_layers_ortos;

    },

    f_load_vista3d_info: function() {

        let b_page_in_ext_context = xCore.application.b_page_in_ext_context;

        let s_vista_3d_base_url = xCore.application.endpoints.vista_3d.vista_3d_base_url;
        let a_layers_vista_3d = xCore.application.endpoints.vista_3d.a_layers_vista_3d;

        let a_layers_vista_3d_to_load = [];

        a_layers_vista_3d.forEach( (layer_cfg) => 
        {
            let b_load = !(layer_cfg.b_intranet_only && b_page_in_ext_context);
            if(b_load)
            {
                a_layers_vista_3d_to_load.push(layer_cfg);
            }
        } );

        this.private_objs.a_layers_vista_3d = a_layers_vista_3d_to_load;

    },

    f_load_atlas_info: function() {

        let s_atlas_base_url = xCore.application.endpoints.atlas.atlas_base_url;
        let a_layers_atlas = xCore.application.endpoints.atlas.a_layers_atlas;

        this.private_objs.a_layers_atlas = a_layers_atlas;

    },


    f_create_page_html: function()
	{
        if( !xCoreHelper.f_page_is_in_mini_client_mode() )
        {
            this.f_create_page_html_normal_version();
        }
        else
        {
            this.f_create_page_html_mini_client_version();
        }
    },

    f_create_page_html_normal_version: function()
	{
		let this_ = this;
		let private_objs = this.private_objs;


        //appending to element
        NSFunctions.f_dom_elem_preappend_dom_childs_by_html(document.querySelector('#header'), '<div id="header-layer-select-buttons"></div>', '.collapsable-toolbar');  
        let e_parent = document.getElementById("header-layer-select-buttons");

        //Carto
        let o_dd_carto_in = new this.objs.DropDownMapBaseLayer_IN();
        o_dd_carto_in.e_parent = e_parent;
        o_dd_carto_in.s_base_div_id = "div_map_base_layer_select";
        o_dd_carto_in.s_title = "Carto";
        o_dd_carto_in.a_layer_info = this.private_objs.a_layers;
        o_dd_carto_in.f_base_menu_click = function (){ this_.f_carto_menu_click();};
        o_dd_carto_in.b_scroll_down_on_base_menu_first_click = false;
        o_dd_carto_in.f_option_click = function (o_layer_info, element){ this_.f_carto_option_click(o_layer_info, element)};
        o_dd_carto_in.s_base_div_CSS = "layer-select-button";
        o_dd_carto_in.s_options_div_CSS = "layer-select-button-options";
        o_dd_carto_in.s_option_highlight_CSS = "active";
        o_dd_carto_in.b_hidden_options_list = true;
        o_dd_carto_in.s_extra_html = 
            `<div class="form-check form-check-danger left">
                <input class="form-check-input" type="checkbox" id="planimetria-toggle" checked>
                <label class="form-check-label" for="planimetria-toggle">Planimetria</label>
            </div>
            <div class="form-check form-check-danger right">
                <label class="form-check-label" for="altimetria-toggle">Altimetria</label>
                <input class="form-check-input" type="checkbox" id="altimetria-toggle">
            </div>`;

        let o_dd_carto = new this.objs.DropDownMapBaseLayer(o_dd_carto_in);

        private_objs.o_dd_carto = o_dd_carto;

         
		let e_div_map_base_layer_select = document.getElementById("div_map_base_layer_select");
        private_objs.e_div_map_base_layer_select = e_div_map_base_layer_select;

        e_div_map_base_layer_select.querySelector('#planimetria-toggle').onclick = (evt) => { this.f_planimetria_toggle(evt.target.checked); evt.stopPropagation(); }
        e_div_map_base_layer_select.querySelector('#altimetria-toggle').onclick = (evt) => { this.f_altimetria_toggle(evt.target.checked); evt.stopPropagation(); }


        //Ortos
        
        let o_dd_ortos_in = new this.objs.DropDownMapBaseLayer_IN();
        o_dd_ortos_in.e_parent = e_parent;
        o_dd_ortos_in.s_base_div_id = "div_ortos_layer_select";
        o_dd_ortos_in.s_title = "Ortos";
        o_dd_ortos_in.a_layer_info = this.private_objs.a_layers_ortos;
        o_dd_ortos_in.f_base_menu_click = function (){ this_.f_ortos_menu_click();};
        o_dd_ortos_in.b_scroll_down_on_base_menu_first_click = true;
        o_dd_ortos_in.f_option_click = function (o_layer_info, element){ this_.f_ortos_option_click(o_layer_info, element)};
        o_dd_ortos_in.s_base_div_CSS = "layer-select-button";
        o_dd_ortos_in.s_options_div_CSS = "layer-select-button-options";
        o_dd_ortos_in.s_option_highlight_CSS = "active";

        let o_dd_ortos = new this.objs.DropDownMapBaseLayer(o_dd_ortos_in);

        private_objs.o_dd_ortos = o_dd_ortos;

         
		let e_div_ortos_layer_select = document.getElementById("div_ortos_layer_select");
        private_objs.e_div_ortos_layer_select = e_div_ortos_layer_select;


        //Vistas
        {
            let s_base_div_id = 'div_vistas_mode_button';
            let s_base_div_CSS = 'layer-select-button';
            let s_title = 'Vistas';

            let s_html = `
                <div id="${s_base_div_id}" class="${s_base_div_CSS}"> 
                    <div class="selection-button">
                        <div class="button-content">
                            <span class="button-title">${s_title}</span>
                        </div>
                    </div>
                </div>
            `;
            
            NSFunctions.f_dom_elem_append_dom_childs_by_html(e_parent, s_html);  

            let e_div_vistas_mode_button = document.getElementById("div_vistas_mode_button");
            private_objs.e_div_vistas_mode_button = e_div_vistas_mode_button;

            e_div_vistas_mode_button.onclick = () => this_.f_vistas_mode_button_click();

        }
        
        // Vista3d Menu:
        {
            
		    let b_page_in_ext_context = xCore.application.b_page_in_ext_context;
            let b_vista3d_menu_is_available = true;   //!b_page_in_ext_context;
            private_objs.b_vista3d_menu_is_available = b_vista3d_menu_is_available;

            if(b_vista3d_menu_is_available) // Vista3d menu is not active/available in external mode (internet)
            {
                let o_dd_vista3d_in = new this.objs.DropDownMapBaseLayer_IN();
                o_dd_vista3d_in.e_parent = e_parent;
                o_dd_vista3d_in.s_base_div_id = "div_vista3d_layer_select";
                o_dd_vista3d_in.s_title = "3D";
                o_dd_vista3d_in.a_layer_info = this.private_objs.a_layers_vista_3d;
                o_dd_vista3d_in.f_base_menu_click = function (){ this_.f_vista3d_menu_click();};
                o_dd_vista3d_in.b_scroll_down_on_base_menu_first_click = false;                
                o_dd_vista3d_in.f_option_click = function (o_layer_info, element){ this_.f_vista3d_option_click(o_layer_info, element)};
                o_dd_vista3d_in.s_base_div_CSS = "layer-select-button";
                o_dd_vista3d_in.s_options_div_CSS = "layer-select-button-options";
                o_dd_vista3d_in.s_option_highlight_CSS = "active";
    
                let o_dd_vista3d = new this.objs.DropDownMapBaseLayer(o_dd_vista3d_in);
    
                private_objs.o_dd_vista3d = o_dd_vista3d;
    
                
                let e_div_vista3d_layer_select = document.getElementById("div_vista3d_layer_select");
                private_objs.e_div_vista3d_layer_select = e_div_vista3d_layer_select;
            }
            
        }

        // Atlas Menu:
        {
            
		    let b_page_in_ext_context = xCore.application.b_page_in_ext_context;
            let b_atlas_menu_is_available = !b_page_in_ext_context;
            private_objs.b_atlas_menu_is_available = b_atlas_menu_is_available;

            if(b_atlas_menu_is_available) // Atlas menu is not active/available in external mode (internet)
            {
                let o_dd_atlas_in = new this.objs.DropDownMapBaseLayer_IN();
                o_dd_atlas_in.e_parent = e_parent;
                o_dd_atlas_in.s_base_div_id = "div_atlas_layer_select";
                o_dd_atlas_in.s_title = "Atlas";
                o_dd_atlas_in.a_layer_info = this.private_objs.a_layers_atlas;
                o_dd_atlas_in.f_base_menu_click = function (){ this_.f_atlas_menu_click();};
                o_dd_atlas_in.b_scroll_down_on_base_menu_first_click = false;
                o_dd_atlas_in.f_option_click = function (o_layer_info, element){ this_.f_atlas_option_click(o_layer_info, element)};
                o_dd_atlas_in.s_base_div_CSS = "layer-select-button";
                o_dd_atlas_in.s_options_div_CSS = "layer-select-button-options";
                o_dd_atlas_in.s_option_highlight_CSS = "active";
    
                let o_dd_atlas = new this.objs.DropDownMapBaseLayer(o_dd_atlas_in);
    
                private_objs.o_dd_atlas = o_dd_atlas;
    
                
                let e_div_atlas_layer_select = document.getElementById("div_atlas_layer_select");
                private_objs.e_div_atlas_layer_select = e_div_atlas_layer_select;
            }
            
        }

    },

    f_create_page_html_mini_client_version: function()
    {
        let this_ = this;

        let s_title_button_carto = "Carto";
        let s_title_button_orto = "Orto";

        let s_html = `
            <div id="layer-select-toolbar" class="btn-group" role="group" aria-label="">
                <button id="button_map_base_layer_carto" type="button" class="btn btn-danger" title="${s_title_button_carto}"><span>${s_title_button_carto}</span></button>
                <button id="button_map_base_layer_orto" type="button" class="btn btn-danger" title="${s_title_button_orto}"><span>${s_title_button_orto}</span></button>
            </div>
        `;

        let e_parent = document.querySelector('#header');
        NSFunctions.f_dom_elem_append_dom_childs_by_html(e_parent, s_html);  

        let e_button_map_base_layer_carto = document.getElementById("button_map_base_layer_carto");
        this.private_objs.o_mini_client.e_button_map_base_layer_carto = e_button_map_base_layer_carto;
        e_button_map_base_layer_carto.onclick = function (e) {
            this_.f_carto_option_click_for_mini_client_version();
            e.stopPropagation();
        };

        let e_button_map_base_layer_orto = document.getElementById("button_map_base_layer_orto");
        this.private_objs.o_mini_client.e_button_map_base_layer_orto = e_button_map_base_layer_orto;
        e_button_map_base_layer_orto.onclick = function (e) {
            this_.f_orto_option_click_for_mini_client_version();
            e.stopPropagation();
        };
    },
    
    f_carto_option_click_for_mini_client_version: function()
    {
        let o_layer_info_0 = this.private_objs.a_layers[0];

        let internal_name = o_layer_info_0.internal_name;
        let external_name = o_layer_info_0.external_name;

        Module_Map.f_set_layer_by_internal_name(internal_name);

        this.private_objs.o_mini_client.e_button_map_base_layer_carto.style.opacity = '1.0';
        this.private_objs.o_mini_client.e_button_map_base_layer_orto.style.opacity = '0.65';
    },

    f_orto_option_click_for_mini_client_version: function()
    {
        let o_layer_info_i = this.private_objs.a_layers_ortos[this.private_objs.a_layers_ortos.length-1]; // last is the latest

        let internal_name = o_layer_info_i.internal_name;
        let external_name = o_layer_info_i.external_name;

        Module_Map.f_set_layer_by_internal_name(internal_name);

        this.private_objs.o_mini_client.e_button_map_base_layer_carto.style.opacity = '0.65';
        this.private_objs.o_mini_client.e_button_map_base_layer_orto.style.opacity = '1.0';
    },

    f_carto_option_click: function(o_layer_info, element)
    {
        let internal_name = o_layer_info.internal_name;
        let external_name = o_layer_info.external_name;

        Module_Map.f_set_layer_by_internal_name(internal_name);

        //set style
        let map_viewport_mode = this.private_objs.ENUM_MAP_VIEWPORT_MODE.CARTO;
        this.f_map_viewport_mode_control_click_set_style(map_viewport_mode);
        
        this.f_planimetria_toggle(this.private_objs.e_div_map_base_layer_select.querySelector('#planimetria-toggle').checked);
        this.f_altimetria_toggle(this.private_objs.e_div_map_base_layer_select.querySelector('#altimetria-toggle').checked);

        this.f_unset_iframe();
    },
    f_ortos_option_click: function(o_layer_info, element)
    {
        let internal_name = o_layer_info.internal_name;
        let external_name = o_layer_info.external_name;

        Module_Map.f_set_layer_by_internal_name(internal_name);

        //set style
        let map_viewport_mode = this.private_objs.ENUM_MAP_VIEWPORT_MODE.ORTOS;
        this.f_map_viewport_mode_control_click_set_style(map_viewport_mode);

        this.f_planimetria_toggle(false);
        this.f_altimetria_toggle(false);

        this.f_unset_iframe();
    },
    f_planimetria_toggle: function(b_state) {
        Module_Map.f_set_layer_planimetria(b_state);
    },
    f_altimetria_toggle: function(b_state) {
        Module_Map.f_set_layer_altimetria(b_state);
    },
    /**
     * 
     * @param {private_objs.ENUM_MAP_VIEWPORT_MODE} map_viewport_mode 
     * 
     */
    f_map_viewport_mode_control_click_set_style: function(map_viewport_mode)
    {
        let ENUM_MAP_VIEWPORT_MODE = this.private_objs.ENUM_MAP_VIEWPORT_MODE;

        let s_highlight_CSS = "active";
        let e_div_map_base_layer_select = this.private_objs.e_div_map_base_layer_select;
        let e_div_ortos_layer_select = this.private_objs.e_div_ortos_layer_select;
        let e_div_vistas_mode_button = this.private_objs.e_div_vistas_mode_button;
        let e_div_vista3d_layer_select = this.private_objs.e_div_vista3d_layer_select;
        let e_div_atlas_layer_select = this.private_objs.e_div_atlas_layer_select;

        let b_atlas_menu_is_available = this.private_objs.b_atlas_menu_is_available;

        if(map_viewport_mode == ENUM_MAP_VIEWPORT_MODE.CARTO)            //Carto
        {
            NSFunctions.elem_addClass(e_div_map_base_layer_select, s_highlight_CSS);
            NSFunctions.elem_removeClass(e_div_ortos_layer_select, s_highlight_CSS);
            NSFunctions.elem_removeClass(e_div_vistas_mode_button, s_highlight_CSS);
            NSFunctions.elem_removeClass(e_div_vista3d_layer_select, s_highlight_CSS);
            if(b_atlas_menu_is_available)
            {
                NSFunctions.elem_removeClass(e_div_atlas_layer_select, s_highlight_CSS);
            }
        }
        else if (map_viewport_mode == ENUM_MAP_VIEWPORT_MODE.ORTOS)      //Ortos
        {
            NSFunctions.elem_removeClass(e_div_map_base_layer_select, s_highlight_CSS);
            NSFunctions.elem_addClass(e_div_ortos_layer_select, s_highlight_CSS);
            NSFunctions.elem_removeClass(e_div_vistas_mode_button, s_highlight_CSS);
            NSFunctions.elem_removeClass(e_div_vista3d_layer_select, s_highlight_CSS);
            if(b_atlas_menu_is_available)
            {
                NSFunctions.elem_removeClass(e_div_atlas_layer_select, s_highlight_CSS);
            }
        }
        else if (map_viewport_mode == ENUM_MAP_VIEWPORT_MODE.VISTAS)      //Vistas
        {
            NSFunctions.elem_removeClass(e_div_map_base_layer_select, s_highlight_CSS);
            NSFunctions.elem_removeClass(e_div_ortos_layer_select, s_highlight_CSS);
            NSFunctions.elem_addClass(e_div_vistas_mode_button, s_highlight_CSS);
            NSFunctions.elem_removeClass(e_div_vista3d_layer_select, s_highlight_CSS);
            if(b_atlas_menu_is_available)
            {
                NSFunctions.elem_removeClass(e_div_atlas_layer_select, s_highlight_CSS);
            }
        }
        else if (map_viewport_mode == ENUM_MAP_VIEWPORT_MODE.VISTA3D_MENU)   //Vista3d Menu
        {
            NSFunctions.elem_removeClass(e_div_map_base_layer_select, s_highlight_CSS);
            NSFunctions.elem_removeClass(e_div_ortos_layer_select, s_highlight_CSS);
            NSFunctions.elem_removeClass(e_div_vistas_mode_button, s_highlight_CSS);
            NSFunctions.elem_addClass(e_div_vista3d_layer_select, s_highlight_CSS);
            if(b_atlas_menu_is_available)
            {
                NSFunctions.elem_removeClass(e_div_atlas_layer_select, s_highlight_CSS);
            }
        }
        else if (map_viewport_mode == ENUM_MAP_VIEWPORT_MODE.ATLAS)   //Atlas
        {
            NSFunctions.elem_removeClass(e_div_map_base_layer_select, s_highlight_CSS);
            NSFunctions.elem_removeClass(e_div_ortos_layer_select, s_highlight_CSS);
            NSFunctions.elem_removeClass(e_div_vistas_mode_button, s_highlight_CSS);
            NSFunctions.elem_removeClass(e_div_vista3d_layer_select, s_highlight_CSS);
            if(b_atlas_menu_is_available)
            {
                NSFunctions.elem_addClass(e_div_atlas_layer_select, s_highlight_CSS);
            }
        }
 
    },
    
    f_carto_menu_click: function(element, internal_name, external_name)
    {
        this.private_objs.o_dd_ortos.f_hide_options(); 
        this.private_objs.o_dd_vista3d?.f_hide_options(); 
        this.private_objs.o_dd_atlas?.f_hide_options(); 
    },
    
    f_ortos_menu_click: function(element, internal_name, external_name)
    {
        this.private_objs.o_dd_carto.f_hide_options(); 
        this.private_objs.o_dd_vista3d?.f_hide_options(); 
        this.private_objs.o_dd_atlas?.f_hide_options(); 
    },
    
    f_vista3d_menu_click: function(element, internal_name, external_name)
    {
        this.private_objs.o_dd_ortos.f_hide_options(); 
        this.private_objs.o_dd_carto.f_hide_options(); 
        this.private_objs.o_dd_atlas?.f_hide_options(); 
    },
    
    f_atlas_menu_click: function(element, internal_name, external_name)
    {
        this.private_objs.o_dd_ortos.f_hide_options(); 
        this.private_objs.o_dd_carto.f_hide_options(); 
        this.private_objs.o_dd_vista3d?.f_hide_options(); 
    },
    
    f_vistas_mode_button_click: function(b_open_vistas_rua_mode ,x, y)
    {
        this.private_objs.o_dd_ortos.f_hide_options(); 
        this.private_objs.o_dd_carto.f_hide_options(); 
        this.private_objs.o_dd_vista3d?.f_hide_options(); 
        this.private_objs.o_dd_atlas?.f_hide_options(); 

        
        //set style
        let map_viewport_mode = this.private_objs.ENUM_MAP_VIEWPORT_MODE.VISTAS;
        this.f_map_viewport_mode_control_click_set_style(map_viewport_mode);

        
        let s_url = xCore.application.endpoints.vistas_base_url;
        let b_standard_mode = (b_open_vistas_rua_mode)? false : true;
        if(b_standard_mode) {
            let a_center_3857 = Module_Map.f_get_map_center();
            s_url += `?d=0&l=-1&r=0&z=18&x=${a_center_3857[0]}&y=${a_center_3857[1]}`;
        }
        else {
            /*
                To open in stree view mode (vistas de rua)
                https://geovistas.cm-cascais.pt/?d=0&l=-1&r=0&z=18&x=-1045849.639511924&y=4679530.970442917&k=orto&sv=true
            */
            let a_center_3857 = [x,y];
            s_url += `?d=0&l=-1&r=0&z=18&x=${a_center_3857[0]}&y=${a_center_3857[1]}&k=orto&sv=true`;
            console.log(s_url);

        }
        
        this.f_set_iframe(s_url);

    },
    
    f_vista3d_option_click: function(o_layer_info, element)
    {
        this.private_objs.o_dd_ortos.f_hide_options(); 
        this.private_objs.o_dd_carto.f_hide_options(); 
        this.private_objs.o_dd_vista3d.f_hide_options(); 
        this.private_objs.o_dd_atlas?.f_hide_options(); 

        
        let internal_name = o_layer_info.internal_name;
        let external_name = o_layer_info.external_name;
        let s_path = o_layer_info.path;

        
        //set style
        let map_viewport_mode = this.private_objs.ENUM_MAP_VIEWPORT_MODE.VISTA3D_MENU;
        this.f_map_viewport_mode_control_click_set_style(map_viewport_mode);

        let s_base_url = xCore.application.endpoints.vista_3d.vista_3d_base_url;
        let s_url = s_base_url + s_path;
                
        let a_center_3857 = Module_Map.f_get_map_center();
        let a_center_3763 = NSCRS.f_convert_xy_from_EPSG3857_to_ETRS89_PT_TM06(a_center_3857);
        //s_url += `&center=${a_center_3763.toString()},3763`;
        s_url += `&viewpoint=cam:${a_center_3763.toString()},1000,3763;0,0.5`;
        this.f_set_iframe(s_url);

    },
    
    f_atlas_option_click: function(o_layer_info, element)
    {
        this.private_objs.o_dd_ortos.f_hide_options(); 
        this.private_objs.o_dd_carto.f_hide_options(); 
        this.private_objs.o_dd_vista3d?.f_hide_options(); 
        this.private_objs.o_dd_atlas.f_hide_options(); 

        
        let internal_name = o_layer_info.internal_name;
        let external_name = o_layer_info.external_name;
        let s_path = o_layer_info.path;

        
        //set style
        let map_viewport_mode = this.private_objs.ENUM_MAP_VIEWPORT_MODE.ATLAS;
        this.f_map_viewport_mode_control_click_set_style(map_viewport_mode);

        let s_base_url = xCore.application.endpoints.atlas.atlas_base_url;
        let s_url = s_base_url + s_path;
        //let s_url = s_path;
        let a_center_3857 = Module_Map.f_get_map_center();
        let a_center_3763 = NSCRS.f_convert_xy_from_EPSG3857_to_ETRS89_PT_TM06(a_center_3857);
        //s_url += `&center=${a_center_3763.toString()},3763`;
        //s_url += '?' + `&viewpoint=cam:${a_center_3763.toString()},1000,3763;0,0.5`;
        s_url += "";
        this.f_set_iframe(s_url);

    },

    f_set_iframe(s_url)
    {
        let e_ = document.getElementById("id_iframe");
        let e_div_iframe_holder = document.getElementById('div_iframe_holder');

        e_.setAttribute('src', s_url);
        if(s_url != null && s_url.length > 0)
        {
            //to request full screen
            //e_.requestFullscreen();
            e_div_iframe_holder.style.display = '';
        }
        else {
            e_div_iframe_holder.style.display = 'none';
        }
    },

    f_unset_iframe()
    {
        this.f_set_iframe("");
    },

    f_iframe_is_visible()
    {
        let e_div_iframe_holder = document.getElementById('div_iframe_holder');
        
        let b_iframe_is_visible = (e_div_iframe_holder.style.display != 'none') ? true : false;
        return b_iframe_is_visible;
    },

    f_if_iframe_is_visible_activate_default_map()
    {
        let b_iframe_is_visible = this.f_iframe_is_visible();
        if( b_iframe_is_visible )
        {
            this.f_set_default_layer();
        }
    },

    f_open_vistas_sv_mode(b_open_vistas_rua_mode ,x, y)
    {
        this.f_vistas_mode_button_click(b_open_vistas_rua_mode ,x, y);
    },
    

   
    objs: {
        /**
         * @param {DropDownMapBaseLayer_IN} o_in 
         */
        DropDownMapBaseLayer: function(o_in)
        {
            this.private_objs = {
                e_parent: o_in.e_parent,
                s_base_div_id: o_in.s_base_div_id,
                s_title: o_in.s_title,
                a_layer_info: o_in.a_layer_info,
                f_base_menu_click: o_in.f_base_menu_click,
                b_scroll_down_on_base_menu_first_click: o_in.b_scroll_down_on_base_menu_first_click,
                b_base_menu_first_click_occurred: false,
                f_option_click: o_in.f_option_click,
                s_base_div_CSS: o_in.s_base_div_CSS,
                s_options_div_CSS: o_in.s_options_div_CSS,
                s_option_highlight_CSS: o_in.s_option_highlight_CSS,
                b_hidden_options_list: o_in.b_hidden_options_list,
                s_extra_html: o_in.s_extra_html,

                e_div_map_base_layer_select: null,
                e_div_map_base_layer_select_options: null,
                e_span_map_base_select_preview: null,

                a_e_div_option: null

            };

            this._contructor_part_2();

        },

        /**
         * @property {Element}      e_parent                -> Document Element that will parent control
         * @property {String}       s_base_div_id 
         * @property {[LayerInfo]}  a_layer_info 
         * @property {Function}     f_base_menu_click       -> function ()
         * @property {bool}         b_scroll_down_on_base_menu_first_click
         * @property {Function}     f_option_click          -> function (LayerInfo o, Element e)
         * @property {String}       s_base_div_CSS          -> name of CSS to be used in base div
         * @property {String}       s_options_div_CSS       -> name of CSS to be used in optios div
         * @property {String}       s_option_highlight_CSS  -> name of CSS to be used in option highlight
         * @property {String}       s_extra_html            -> extra html
         */
        DropDownMapBaseLayer_IN: function()
        {
            this.e_parent = null;
            this.s_base_div_id = null;
            this.s_title = null;
            this.a_layer_info = null;           // [{external_name,...},...]
            this.f_base_menu_click = null;      // f_base_menu_click (o_layer_info)
            this.b_scroll_down_on_base_menu_first_click = null;
            this.f_option_click = null;         // function (o_layer_info)
            this.s_base_div_CSS = null;         // name of CSS to be used in base div
            this.s_options_div_CSS = null;      // name of CSS to be used in options div
            this.s_option_highlight_CSS = null;
            this.b_hidden_options_list = null; // name of CSS to be used in option highlight
            this.s_extra_html = null;           // extra html
        },
        /**
         * Abstract Class
         *  Caller is suposed to add all needed data for the layer processing.
         *  "external_name" will be used in the option,
         *  this whole object will be passed to f_option_click function.
         * 
         * @example {external_name: "A A", internal_name: "a_a", extra_data: {...} }}
         */
        LayerInfo: function()
        {
            this.external_name;  // function (o_layer_info)
            
        },



        
        init: function()
        {

            this.DropDownMapBaseLayer.prototype._contructor_part_2 = function ()
            {
                let this_ = this;

                let private_objs = this.private_objs;
                let e_parent = private_objs.e_parent;
                let s_title = private_objs.s_title;
                let s_base_div_id = private_objs.s_base_div_id;
                let s_base_div_CSS = private_objs.s_base_div_CSS;
                let s_span_preview_id = "span_" + s_base_div_id;
                let s_options_div_id = s_base_div_id + "_options";
                let s_options_div_CSS = private_objs.s_options_div_CSS;
                let s_extra_html = private_objs.s_extra_html;
                
                let s_html = `
                    <div id="${s_base_div_id}" class="${s_base_div_CSS}"> 
                        <div class="selection-button">
                            <div class="button-content">
                                <span class="button-title">${s_title}</span>
                                ${s_extra_html || ''}
                            </div>
                            <div id="${s_span_preview_id}" class="current-selection" ></div>
                        </div>
                        <div id="${s_options_div_id}" class="${s_options_div_CSS}" ></div>
                    </div>
                `;
                
                NSFunctions.f_dom_elem_append_dom_childs_by_html(e_parent, s_html);  

                //init style
                {
                    let s_style_display = private_objs.b_hidden_options_list ? 'none' : '';
                    
                    let elem = document.getElementById(s_span_preview_id);
                    elem.style.display = s_style_display;
                    elem = document.getElementById(s_options_div_id);
                    elem.style.display = s_style_display;
                }
                
                // if (private_objs.b_hidden_options_list) {
                //     private_objs.f_option_click(private_objs.a_layer_info[0]);
                //     return;
                // }

                let e_div_map_base_layer_select = document.querySelector(`#${s_base_div_id}`);
                if(!private_objs.b_hidden_options_list) e_div_map_base_layer_select.onclick = () => this.f_base_menu_click();
                if(private_objs.b_hidden_options_list) e_div_map_base_layer_select.onclick = () => private_objs.f_option_click(private_objs.a_layer_info[0]);

                this.private_objs.e_div_map_base_layer_select = e_div_map_base_layer_select;
                
                let e_div_map_base_layer_select_options = document.getElementById(s_options_div_id);

                this.private_objs.e_div_map_base_layer_select_options = e_div_map_base_layer_select_options;

                this.f_hide_options_with_no_animation();
        
                let a_e_div_option = [];
                private_objs.a_layer_info.forEach((o_layer_i) => {
                    let e_div_option = document.createElement("div");
                    a_e_div_option.push(e_div_option);
        
                    s_html = '<span >' + o_layer_i.external_name + '</span>';
                    NSFunctions.f_dom_elem_append_dom_childs_by_html(e_div_option, s_html);  
                    e_div_map_base_layer_select_options.appendChild(e_div_option);
                    e_div_option.onclick = function(e)
                    {
                        //this_.f_option_click(e_div_option, o_layer_i.internal_name, o_layer_i.external_name);
                        this_.f_option_click(e_div_option, o_layer_i);

                        if (e !== undefined) e.stopPropagation();
                    };  
                });
                private_objs.a_e_div_option = a_e_div_option;        
        
                private_objs.e_span_map_base_select_preview = document.getElementById(s_span_preview_id);
            };
            
            
            this.DropDownMapBaseLayer.prototype.f_get_base_element = function()
            {
                return this.private_objs.e_div_map_base_layer_select;
            };

            this.DropDownMapBaseLayer.prototype.f_show_options = function()
            {
                this.private_objs.e_div_map_base_layer_select_options.style.display = "";
            },
            this.DropDownMapBaseLayer.prototype.f_hide_options = function()
            {
                this.private_objs.e_div_map_base_layer_select_options.style.display = "none";
            },
            this.DropDownMapBaseLayer.prototype.f_hide_options_with_no_animation = function()
            {
                this.private_objs.e_div_map_base_layer_select_options.style.display = 'none';
            },
            this.DropDownMapBaseLayer.prototype.f_set_menu_selected_option_preview = function(external_name)
            {
                this.private_objs.e_span_map_base_select_preview.innerHTML = ''+external_name;
            },
            this.DropDownMapBaseLayer.prototype.f_set_option_selected_highlight = function(e_div_option)
            {
                this.f_clean_all_option_selected_highlight();
                NSFunctions.elem_addClass(e_div_option, this.private_objs.s_option_highlight_CSS);
        
            },
            this.DropDownMapBaseLayer.prototype.f_clean_all_option_selected_highlight = function()
            {
                this.private_objs.a_e_div_option.forEach((e_div_option)=>
                {
                    NSFunctions.elem_removeClass(e_div_option, this.private_objs.s_option_highlight_CSS);
                })
        
            },
            this.DropDownMapBaseLayer.prototype.f_option_click = function(element, o_layer_i)
            {
                let external_name =  o_layer_i.external_name
        
                this.private_objs.f_option_click(o_layer_i, element); //calling external method
         
                this.f_set_menu_selected_option_preview(external_name);
        
                this.f_set_option_selected_highlight(element);
        
                this.f_hide_options();
         
            },
            this.DropDownMapBaseLayer.prototype.f_base_menu_click = function()
            {
                this.private_objs.f_base_menu_click(); //calling external method

                this.f_show_options();

                if(this.private_objs.b_scroll_down_on_base_menu_first_click)
                {
                    if(!this.private_objs.b_base_menu_first_click_occurred)
                    {
                        // scroll div to bottom:
                        let e_div_map_base_layer_select_options = this.private_objs.e_div_map_base_layer_select_options;
                        e_div_map_base_layer_select_options.scrollTop = e_div_map_base_layer_select_options.scrollHeight;
                        
                        this.private_objs.b_base_menu_first_click_occurred = true;
                    }
                }
         
            },

            
            this.DropDownMapBaseLayer.prototype.f_trigger_default_layer = function()
            {
                this.private_objs.a_e_div_option[0].onclick();
            }



        }

    }

    
}